import { Stack, Title, Text, Container } from "@mantine/core";

export const Intro = () => {
  return (
    <>
      <Container size="md">
        <Stack>
          <Title ta="center" order={2}>
            Seien Sie bei unserer Mitgliederwoche dabei
          </Title>
          <Text ta="center">
            Wir laden Sie herzlich zu unserer Mitgliederwoche ein! Vier
            Infoabende, vier moderne, kurzweilige Vorträge, die wir Ihnen als
            Mitglied der Volksbank PLUS exklusiv anbieten. Jeder Expertenvortrag
            dauert ca. eine Stunde. Am Veranstaltungsort laden wir Sie zu
            kostenfreien Getränken ein. Melden Sie sich bitte zu einem der vier
            Abende an.
          </Text>
          <Text ta="center">
            Jeder Vortrag findet in der{" "}
            <a href="https://www.freiraum-54.de/">
              Event- und Businesslocation FREIRAUM 54
            </a>{" "}
            statt. Die Räume sind ebenerdig. Einige Stellplätze sind direkt an
            der Location, weitere Parkmöglichkeiten sind in der anliegenden
            Seitenstraße sowie auf den Großparkplätzen des Kauflands und des
            Fachmarktzentrums an der Strubbergstr.
          </Text>
          <Text ta="center">
            Viel Spaß mit unserer Mitgliederwoche, wir freuen uns auf Sie!
          </Text>
        </Stack>
      </Container>
    </>
  );
};
